export default [
  {
    path: 'resumes',
    component: () => import('@/layouts/GroupLayout'),
    children: [
      {
        path: '',
        component: () => import('@/pages/resume/Index'),
        name: 'resume.index',
      },
      {
        path: 'thank-you',
        component: () => import('@/pages/resume/SubmitThankYou'),
        name: 'resume.submit-thank-you',
      },
    ],
  },
];
